import { render, staticRenderFns } from "./bookaccounting.vue?vue&type=template&id=71adbed3"
import script from "./bookaccounting.vue?vue&type=script&lang=js"
export * from "./bookaccounting.vue?vue&type=script&lang=js"
import style0 from "./bookaccounting.vue?vue&type=style&index=0&id=71adbed3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports